export const toFixedNumber = (num: number, digits: number, base: number = 10): number => {
  var pow = Math.pow(base, digits);
  return Math.round(num * pow) / pow;
};
